
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {  Chip, Link, Theme, Typography, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";

export type AlarmNotificationChipProps = {
    text: string;
    color?: string;
    size: 'small' | 'medium',
    typographyProps?: SxProps<Theme>,
    onClick?: () => void;
    showSort?: boolean;
    sortAscending?: boolean;
};

export function AlarmNotificationChip({
    text,
    color,
    size,
    typographyProps,
    onClick,
    showSort,
    sortAscending
}: AlarmNotificationChipProps) {

    const theme = useTheme();

    return (

        <Link
            sx={{
                display: 'flex',
                color: "text.primary",
                "&:hover": {
                    cursor: "pointer"
                },
                alignItems: 'center',
                overflow: 'hidden',
                marginRight: 1
            }}
            onClick={() => onClick && onClick()}
        >
            <Chip sx={{ 
                backgroundColor: color,
                borderRadius: size === 'small' ? '4px' : '6px',
                width: size === 'small' ? 16 : 24,
                height: size === 'small' ? 8 : 12,
                }} 
                size="small"/>


                <Typography variant='subtitle2' 
                    sx={{
                        textAlign: 'left',
                        padding: theme.spacing(.5),
                        color: theme.palette.text.secondary,
                        fontSize: size === 'small' ? '.7rem' : '.8rem',
                        //fontWeight: 600,
                        // whiteSpace: isPhone ? 'nowrap' : undefined,
                        // overflow: isPhone ? 'hidden' : undefined,
                        // textOverflow: isPhone ? 'ellipsis' : undefined
                        whiteSpace: 'nowrap',
                        marginRight: !showSort ? '1em' : undefined,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        ...typographyProps
                }}>
                    {text}
                </Typography>


                {showSort ? sortAscending ?  <ExpandLess 
                                                sx={{
                                                    color: theme.palette.text.secondary
                                                }} /> : 
                                              <ExpandMore
                                                sx={{
                                                    color: theme.palette.text.secondary
                                                }} /> : null}

        </Link>

    );
}
